<template>
    <div class="content_warp">
        <div class="info_wrap">
            <div class="sumNav">
                <div :class="[nSumNavKey == item.key ? 'atvie' : '']" v-for="(item, index) in arrSumNav" :key="index"
                    @click="setSumNav(item.key)">{{ item.name }}</div>
            </div>
            <!-- 施工进度列表 -->
            <div class="constru_lits" v-if="nSumNavKey == 'workorder'&&objData[nSumNavKey].length">
                <template v-for="(item, index) in objData[nSumNavKey]">
                    <div class="constru_lits_warp" v-if="item.is_project_change == 0"
                        @click.stop="item.link_url?$router.push({path:item.link_url,query:{workorderId:item.new_workorder_id}}):''">
                        <div class="constru_item_top">
                            <div :class="['constru_title',getStatusColor(item.process_name)]">{{ item.process_name ||
                            '暂无信息' }}</div>
                            <div :class="['constru_type',getStatusColor(item.status_name)]">{{ item.status_name ||
                            '暂无信息' }}</div>
                        </div>
                        <div class="constru_item_info">
                            <div>计划时间：{{ item.new_planstartdate || '暂无信息' }}</div>
                            <div>施工时间：{{ item.new_actualstartedon || '暂无信息' }} {{ item.new_actualfinishedon || '暂无信息' }}
                            </div>
                            <div>负责人：{{ item.new_worker_name || '暂无信息' }}</div>
                        </div>
                        <!-- <div class="constru_item_btn">
                            <div>派工</div>
                        </div> -->
                        <template v-if="item.need_rectify == 1">
                            <div class="constru_tips" @click.stop="item.rectifyOpen = !item.rectifyOpen">
                                <div class="constru_tips_red">整改通知单</div>
                                <div>{{ item.rectifyOpen ? '收起' : '展开' }}</div>
                            </div>
                            <div class="constru_tips_info" :data-tips="item.rectify.status_name" v-if="item.rectifyOpen"
                                @click.stop="$router.push({path:item.rectify.link_url,query:{workorderId:item.rectify.new_workorder_id}})">
                                <div class="constru_code">
                                    <span>{{item.rectify.wokor_name || '暂无信息'}}</span>
                                </div>
                                <div>整改内容：{{item.rectify.new_name || '暂无信息'}}</div>
                                <div>整改截止时间：{{item.rectify.new_rectifydeadline || '暂无信息'}}</div>
                                <div>整改完成时间：{{item.rectify.new_completetime || '暂无信息'}}</div>
                            </div>
                        </template>
                    </div>
                    <div class="constru_lits_bottom" v-if="item.is_project_change == 1"
                        @click.stop="$router.push({path:item.link_url,query:{type: 'change', contract_id: item.new_contractid, change_id: item.project_change_id}})">
                        <div class="constru_modify">
                            <div>项目发生变更</div>
                        </div>
                        <div class="constru_item_info">
                            <div>变更内容：{{item.content || '暂无信息'}}</div>
                            <div>变更原因：{{item.reaon || '暂无信息'}}</div>
                        </div>
                    </div>
                </template>
            </div>
            <template v-if="nSumNavKey == 'workorder'&&!objData[nSumNavKey].length">
                <div class="dossier-img">
                    <img src="@/assets/images/archives/dossier/contract_not.png" />
                    <div class="noMore">暂无信息</div>
                </div>
            </template>

            <!-- 整改通知单 -->
            <div class="constru_lits" v-if="nSumNavKey == 'rectify'">
                <template v-for="(item, index) in objData[nSumNavKey]">
                    <div class="constru_lits_warp"
                        @click.stop="$router.push({path:item.link_url,query:{workorderId:item.new_workorder_id}})">
                        <div class="constru_item_top">
                            <div class="constru_title pale_bule">{{item.process_name || '暂无信息'}}</div>
                            <div :class="['constru_type', getStatusColor(item.status_name)]">{{item.status_name ||
                            '暂无信息'}}</div>
                        </div>
                        <div class="constru_tong_info">
                            <div>整改单号：{{item.wokor_name || '暂无信息'}}</div>
                            <div>整改内容：{{item.new_name || '暂无信息'}}</div>
                            <div>整改截止时间：{{item.new_rectifydeadline || '暂无信息'}}</div>
                            <div>整改完成时间：{{item.new_completetime || '暂无信息'}}</div>
                            <div>备注：{{item.new_memo || '暂无信息'}}</div>
                        </div>
                    </div>
                </template>
            </div>
            <template v-if="nSumNavKey == 'rectify'&&!objData[nSumNavKey].length">
                <div class="dossier-img">
                    <img src="@/assets/images/archives/dossier/contract_not.png" />
                    <div class="noMore">暂无信息</div>
                </div>
            </template>
        </div>
        <div class="bottom_btns flex aic jue">
            <!-- <button>派工申请</button> -->
            <!-- <button>项目指派</button> -->
        </div>
    </div>
</template>

<script>
import { getWorkorderList } from "@/js/archives/construction.js";
export default {
    name: 'index',
    data() {
        return {
            nSumNavKey: 'workorder',
            arrSumNav: [
                { name: '施工进度', key: 'workorder' },
                { name: '整改通知单', key: 'rectify' },
            ],
            objData: {
                workorder: [{ rectify: {} }],
                rectify: [
                    { rectify: {} }
                ],
            }
        }
    },
    created() {
        let _that = this;
        $init(() => {
            _that.$store.commit("loadSwitch", true);
            _that.getWorkorderList();
        })
    },
    methods: {
        getStatusColor(status) {
            if (status) {
                switch (status) {
                    case '已完工':
                        return 'type_pale_green'
                        break;
                    case '已申请':
                        return 'type_pale_green'
                        break;
                    case '已派工':
                        return 'type_pale_grey'
                        break;
                    case '未派工':
                        return 'type_pale_grey'
                        break;
                    case '整改完成':
                        return 'type_pale_green'
                        break;
                    case '整改中':
                        return 'type_pale_yellow'
                        break;
                    case '定位交底':
                        return 'pale_green'
                        break;
                    case '进场交底':
                        return 'pale_darkgreen'
                        break;
                    case '新风-安装':
                        return 'pale_darkgrey'
                        break;
                    case '空调-系统施工':
                        return 'pale_orange'
                        break;
                }
            }
        },
        //  获取施工进度 & 整改通知单
        getWorkorderList() {
            let _that = this;
            getWorkorderList({ project_id: _that.$route.query.project_id }).then(res => {
                _that.$store.commit("loadSwitch", false);
                if (res.data.error == 0) {
                    let objData = res.data.data.result;
                    objData['workorder'].forEach(it => {
                        if (it.need_rectify == 1) {
                            it.rectifyOpen = true;
                        }
                    })
                    _that.objData = objData
                } else {
                    _that.$toast(res.data.msg);
                }
            }).catch(err => {
                this.objData = {
                    workorder: [],
                    rectify: [],
                }
            })
        },
        setSumNav(key) {
            this.nSumNavKey = key;
        }
    }

}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>